<template>
  <div>
    <list :listTitle="$t('magalu.accounts.label')" :listLogo="definitionModule.logo" filterTitle="Filtros" :typesListAvailable="['displayList']" :loading="loadingSearch || loadingAddAccount" :total="magaluAccountsTotal" :sortFields="sortFields" :sortDefault="{ field: sortFields[0], order: 'asc' }" @change="onChange">
      <div class="btnGroup" slot="header-actions">
        <button @click="modalAddAccountFlag = true" slot="header-actions" class="hint hint--left btn btn--info" data-label="Adicionar conta">
          <i class="icon-plus"/>
        </button>
      </div>

      <template slot="filters">
        <form-group label="Nome">
          <input class="form-input" v-model="options.name">
        </form-group>
      </template>

      <div class="l-col-4@md" v-for="(item, index) in magaluAccounts" :key="index">
        <account :account="item" :accountKey="index"/>
      </div>
      <div class="l-col u-textCenter" v-if="!magaluAccounts.length">
        <panel>
          Nenhuma conta foi encontrada.
        </panel>
      </div>
    </list>
    <modal-add-account v-model="modalAddAccountFlag" v-on:confirm="redirectToAuthorizationUrl"/>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import { mapFields } from 'vuex-map-fields'
  import { getAllUrlParams } from '@/helper'
  import { merge } from 'lodash'
  import Loader from '@/components/template/Loader'
  import PageTitle from '@/components/template/PageTitle'
  import api from '@/api'
  import notifier from '@/notifier'
  import List from '@/components/shared/list/Paginator'
  import Panel from '@/components/template/Panel'
  import FormGroup from '@/components/template/FormGroup'
  import Account from '@/components/marketplace/magalu/Account'
  import ModalAddAccount from '@/components/marketplace/magalu/ModalAddAccount'
  import cookie from 'vue-cookie'
  
  export default {
    data: () => ({
      errors: [],
      loadingAddAccount: false,
      loadingSearch: false,
      type: 'marketplace',
      identifier: 'magalu',
      options: {
        name: ''
      },
      sortFields: [
        'name'
      ],
      account: null,
      modalAddAccountFlag: false
    }),
    mounted () {
      console.log(getAllUrlParams())
      if (getAllUrlParams().code) {
        this.authenticateByCode(getAllUrlParams().code)
      }
    },
    methods: {
      ...mapActions('magaluAccounts', [
        'fetchAccounts',
        'addAccount'
      ]),
      async redirectToAuthorizationUrl () {
        window.location.href = `https://id.magalu.com/login?client_id=XP0pOds6yAEtUiLmCnxZo1kU4ulu73qSAbTbKjqqRyo&redirect_uri=https://backend.placemarket.com.br/webhook/marketplace/magalu/authenticate&scope=apiin:all&response_type=code&choose_tenants=true&state=${cookie.get('merchant')}`
      },
      async onChange (options) {
        this.loadingSearch = true

        merge(this.options, options)

        await this.fetchAccounts({ options: this.options })

        this.loadingSearch = false
      },
      async authenticateByCode (code) {
        this.loadingAddAccount = true

        api.magalu.authenticate(code)
          .then(account => {
            this.loadingAddAccount = false

            this.account = account
          })
          .catch(error => {
            let message = 'Falha ao adicionar a conta.'

            if (error.response.data.message) {
              message = error.response.data.message
            }

            notifier.error(message, 'Não adicionada')
          })
          .finally(() => {
            notifier.success('Conta adicionada com sucesso.', 'Adicionada')

            this.loadingSearch = true

            const url = window.location.origin + window.location.pathname + window.location.hash

            window.history.replaceState(null, '', url)
          })
      }
    },
    computed: {
      ...mapGetters('module', [
        'getDefinitionModuleByIdentifierAndType'
      ]),
      ...mapFields({
        magaluAccountsTotal: 'magaluAccounts.total',
        magaluAccounts: 'magaluAccounts.accounts'
      }),
      definitionModule () {
        return this.getDefinitionModuleByIdentifierAndType(this.type, this.identifier)
      }
    },
    components: {
      ModalAddAccount,
      Loader,
      PageTitle,
      List,
      Panel,
      FormGroup,
      Account
    }
  }
</script>

<style scoped lang="sass">
  .count-selected
    margin-top: 4px

    .logo
      max-height: 30px
      margin-right: 20px

      .title
        margin-top: 16px
        margin-left: 20px

      .paginator
        float: right
</style>



// WEBPACK FOOTER //
// List.vue?0831e9e0